<template>
  <div class="Site IndexBox PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('activity[0]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
		
		<div class="philanthropy-box">
		        <h3 class="philanthropy-title">{{$t('charitable[0]')}}</h3>
            <h3 class="philanthropy-subtitle">{{$t('charitable[5]')}}</h3>
		        <div class="philanthropy-content">
		          <p>{{$t('charitable[1]')}}</p>
              {{$t('charitable[2]')}}
		          <!-- <p class="highlight-text">{{$t('charitable[2]')}}</p> -->
		          <p>{{$t('charitable[3]')}}</p>
		          <!-- <p class="call-to-action">{{$t('charitable[4]')}}</p> -->
		        </div>
		      </div>
		
      <!-- <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
        <van-list
          v-model="isLoad"
          :finished="isFinished"
          :finished-text="listData.length?$t('vanPull[0]'):$t('vanPull[1]')"
          @load="onLoad"
          :class="{Empty:!listData.length}"
        >
          <van-cell :border="false" v-for="item in listData" :key="item.id" style="line-height: 20px;margin: 10px 0px 7px 7px;box-shadow: 5px 5px 10px #ECEFF1">
            <div style="float: left;">
                <img :src="item.cover_img" style="width:100px;height:80px;border-radius: 5px;">
            </div>
			<div style="margin-left: 7rem;height: 80px;overflow: hidden;">
				<p>{{item.title}}</p>
				<p>{{item.name}}</p>
			</div>
			<div style="margin-left: 1rem;"> -->
				<!-- <van-button style="width: 40%;height:40px;float: right;margin-left:.5rem;background: linear-gradient(to right, rgb(55, 119, 76), rgb(55, 119, 76));" @click="openDonate(item)">{{$t('activity[2]')}}</van-button> -->
				<!-- <van-button style="width: 30%;float: right;color: #0e1526; background-color: #fff;height:38px;"  @click="openShow(item)">{{$t('activity[1]')}}</van-button>
			</div>
          </van-cell>
        </van-list>
      </van-pull-refresh> -->
	  <van-cell :border="false" v-for="item in listData" :key="item.id" style="line-height: 20px;margin: 10px 0px 7px 7px;box-shadow: 5px 5px 10px #ECEFF1">
		<div class="Content imgP" style="text-align: justify;color:#333" v-html="item.explain"></div>
	  </van-cell>
	  
    </div>
	<Footer />
	<!-- <van-popup v-model="showCon" position="bottom" closeable close-on-popstate  style="width: 100%;height: 100%;background-color:rgb(255, 255, 255);color:#fff;">
	  <div class="ScrollBox" style="padding: 16px 20px;">
		<div>
			<h3 style="text-align: center;margin-bottom: 5px;color:#333">{{infoData.title}}</h3>
			<p style="text-align: center;margin-bottom: 10px;color:#333">{{infoData.start_time}}~{{infoData.end_time}}</p>
		</div>
	    <div class="Content" style="text-align: justify;color:#333" v-html="infoData.explain"></div>
	  </div>
	</van-popup> -->
	
	<van-action-sheet
	  v-model="showDonate"
	  :title="$t('activity[2]')"
	  close-on-popstate
	  style="background:rgb(55, 119, 76);color: #fff;"
	>
	  <div style="padding: 16px;background: #fff;color:#323233;">
		 <p style="padding: 10px 0;"> {{infoData.title}}</p>
		 <p style="padding: 10px 0;">{{$t("activity[3]")}}：{{ InitData.currency }}{{UserInfo.balance}}</p>
		 <van-field
		   v-model="postData.money"
		   :placeholder="$t('activity[6]')"
		   style="padding: 10px 10px;border: 1px solid #ccc;"
		 />
		 <van-button size="small" round block style="width: 20%;
		float: right;
		color: #fff;
		background-color: rgb(55, 119, 76);
		margin: 5px;
		z-index: 10;
		position: absolute;
		top:9.55rem;
		left: 17rem;" @click="setAll">
		 {{$t("activity[4]")}}</van-button>
	  </div>
	  <div style="padding: 16px;background-color:#ffffff;">
	    <van-button round type="default" block style="font-size: 16px;background: linear-gradient(to right, rgb(55, 119, 76), rgb(55, 119, 76));"
	      @click="doDonate(infoData)"> {{$t("activity[5]")}}</van-button>
	  </div>
	</van-action-sheet>
  </div>
</template>

<script>
export default {
  name: 'Activity',
  components: {
  },
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
	  showCon: false,
	  showDonate:false,
	  infoData: '',
	  postData:{
		  money:'',
		  title:'',
	  }
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getListData('init');
	  this.$Model.GetUserInfo();
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
	doDonate(data){
		if(!this.postData.money){ 
			this.$Dialog.Toast(this.$t('activity[6]'))
			return;
		}
		this.postData.title = data.title;
		this.$Model.doActivity(this.postData,(data)=>{
			if(data.code == 1) {
				this.$Dialog.Toast(this.$t('activity[7]'))
        this.$Model.GetUserInfo();
        this.showDonate = false;
			} else {
				this.$Dialog.Toast(data.msg)
			}
			
		})
	},
	setAll() {
		this.postData.money=this.UserInfo.balance;
	}, 
	openShow(data) {
	  this.showCon = true
	  this.infoData = data
	},
	openDonate(data) {
		this.showDonate = true
		this.infoData = data
	}, 
    onLoad() {
      this.getListData('load')
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      this.$Model.GetActivityList({page_no: this.pageNo},data=>{
        this.$nextTick(()=>{
          this.isLoad = false
        })
        if(data.code==1){

          if(data.info == '') {
            this.isFinished = true;
            return;
          }

          if(type=='load'){
            if(this.pageNo==1){
              this.listData = data.info
            }else{
              this.listData = this.listData.concat(data.info)
            }
          }else{
            this.listData = data.info
          }
          if(this.pageNo==data.data_total_page){
            this.isFinished = true
          }else{
            this.isFinished = false
          }
		  // this.listData[0]['explain'] = '';
		  console.log(this.listData[0]['explain'])
        }else{
          this.listData = ''
          this.isFinished = true
        }
      })
    },
    onRefresh() {
      this.getListData('init')
    },
  }
}
</script>
<style scoped>
.van-pull-refresh{
  min-height: calc(100vh - 46px);
}
::v-deep .van-nav-bar__title{color:#fff}


/* 新增慈善区块样式 */
.philanthropy-box {
  background: linear-gradient(145deg, #f3faf7 0%, #e8f5ec 100%);
  border-radius: 16px;
  margin: 15px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(55, 119, 76, 0.1);
  border: 1px solid rgba(55, 119, 76, 0.15);
}

.philanthropy-title {
  color: #37774c;
  font-size: 1.6em;
  text-align: center;
  margin-bottom: 18px;
  font-weight: 600;
  letter-spacing: -0.5px;
}

.philanthropy-subtitle {
  color: #37774c;
  font-size: 1.1em;
  text-align: center;
  margin-bottom: 18px;
  font-weight: 600;
  letter-spacing: -0.5px;
}
.philanthropy-content {
  color: #4a6655;
  font-size: 0.95em;
  line-height: 1.8;
}

.philanthropy-content p {
  margin-bottom: 15px;
  text-align: justify;
}

.highlight-text {
  background: rgba(85, 170, 0, 0.1);
  padding: 12px;
  border-radius: 8px;
  border-left: 4px solid #37774c;
  font-weight: 500;
}

.call-to-action {
  color: #2b593d;
  font-weight: 600;
  font-style: italic;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .philanthropy-box {    margin: 10px;
    padding: 15px;
  }
  
  .philanthropy-title {
    font-size: 1.4em;
  }
  
  .philanthropy-content {
    font-size: 0.88em;
  }
}

/* 在style标签中添加 */
.imgP ::v-deep img {
  width: 100% !important;
  height: auto !important;
  border-radius: 8px;
  margin: 10px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 如果使用scoped样式 */
::v-deep .imgP img {
  width: 100% !important;
  max-width: 100% !important;
  display: block;
}

</style>